import * as api from "@/api";

const actions = {
  // LOGIN(POST)
  LOGIN({ commit }, { id, password }) {
    /*
    Method: POST
    URI: /login

    Result:
      로그인 유저 데이터를 localStorage와 vuex에 저장.
      토큰을 모든 API 호출을 위해 vuex와 저장하고, request header에 설정.
     */
    return api.auth.login(id, password).then((response) => {
      commit("LOGIN", response);
    });
  },

  // CAMPAIGN(GET(2), POST, UPDATE, DELETE)
  async FETCH_CAMPAIGN({ commit }, { idx }) {
    /*
    Method: GET
    URI: /campaign/<:campaign_idx>

    Result:
      캠페인 정보와 그에 대한 캠페인 아이템들을 vuex의 campaign과 items에 각각 저장.
    */
    const response = await api.campaign.fetch(idx);

    commit("SET_CAMPAIGN", response.campaigns[0]);
    commit("SET_ITEMS", response.campaigns);
  },

  async FETCH_SCEDULE({ commit }, { date }) {
    const data = await api.campaign.schedule(`${date[0]}-${date[1]}`);
    commit("SET_SCHEDULE", data);
  },

  FETCH_CAMPAIGNS({ commit }) {
    /*
    Method: GET
    URI: /campaigns

    Result:
      캠페인 리스트를 vuex의 campaigns에 저장.
    */
    return api.campaign.fetch().then((data) => {
      commit("SET_CAMPAIGNS", data.campaigns);
    });
  },

  /*
    Method: POST
    URI: /campaign

    Result:
      FETCH_CAMPAIGNS
  */
  async ADD_CAMPAIGN({ dispatch }, { payload }) {
    await api.campaign.create(payload);
    dispatch("FETCH_CAMPAIGNS");
  },

  /*
    Method: PUT
    URI: /campaign/<:campaign_idx>

    Result:
      FETCH_CAMPAIGN
  */
  async UPDATE_CAMPAIGN({ dispatch }, { idx, payload }) {
    await api.campaign.update(idx, payload);
    dispatch("FETCH_CAMPAIGNS");
  },

  /*
    Method: POST
    URI: /campaign/<:campaign_idx>
  */
  async DELETE_CAMPAIGN({ dispatch }, { idx }) {
    await api.campaign.destroy(idx);
    dispatch("FETCH_CAMPAIGNS");
  },

  /*
    Method: POST
    URI: /item/<:campaign_idx>

    Result: FETCH_CAMPAIGN
  */
  async ADD_ITEM({ dispatch, state }, { payload }) {
    try {
      await api.item.create(payload);
      dispatch("FETCH_CAMPAIGN", { idx: state.items[0].campaign });
    } catch (err) {
      throw new Error(err.data);
    }
  },

  /*
    Method: PUT
    URI: /item/<:item_idx>

    Result: FETCH_CAMPAIGN
  */
  async UPDATE_ITEM({ state, dispatch }, { idx, payload }) {
    try {
      await api.item.update(idx, payload);
      dispatch("FETCH_CAMPAIGN", { idx: state.items[0].campaign });
    } catch (err) {
      throw new Error(err.data);
    }
  },

  /*
    Method: DELETE
    URI: /item/<:item_idx>

    Result: FETCH_CAMPAIGN
  */
  async DELETE_ITEM({ state, dispatch }, { idx }) {
    await api.item.destroy(idx);
    dispatch("FETCH_CAMPAIGN", { idx: state.items[0].campaign });
  },

  async FETCH_USERS({ commit }, { hook }) {
    /*
    Method: GET
    URI: /ksia_member

    Result: Set store.admin.users
    */
    const data = await api.user.fetch();

    // set local data 검색용도
    hook && hook(data.Ksia_member_db);
    commit("SET_MANAGERS", data.Ksia_member_db);
  },
  ADD_USER(_, { payload }) {
    /*
    Method: POST
    URI: /ksia_member
    */
    return api.user.create(payload);
  },
  async DELETE_USER(_, { idx }) {
    /*
    Method: DELETE
    URI: /ksia_member/<:ksia_member_db_idx>
    */
    await api.user.destroy(idx);
  },

  // statistic
  FETCH_STATISTIC({ commit }, { idx }) {
    /*
    Method: GET
    URI: /stat/<:item_idx>

    Result: Set store.statistic
    */
    return api.statistic.fetch(idx).then((data) => {
      commit("SET_STATISTIC", data);
    });
  },
};

export default actions;
